var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{large: _vm.large},style:({backgroundImage: ("url(" + (require(("@/assets/video/" + _vm.image))) + ")")}),attrs:{"id":"background"}},[_c('div',{attrs:{"id":"play"},on:{"click":_vm.playVideo}},[_c('img',{attrs:{"src":require("@/assets/icons/btn-play@2x.png")}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f65bb3d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-card.vue
// module id = null
// module chunks = 